import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Form, Button, Radio, Message, Table } from "semantic-ui-react";
import ExcelJS from "exceljs"; // Importa la librería ExcelJS
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";

function KardexAlumnos() {
  const { auth } = useAuth();
  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaKardexAlumnos />;
}

function LogicaKardexAlumnos() {
  const { auth } = useAuth();
  const [searchType, setSearchType] = useState("matricula");
  const [searchValue, setSearchValue] = useState("");
  const [alumnoData, setAlumnoData] = useState(null);
  const [calificacionesData, setCalificacionesData] = useState([]);
  const [numeroGrupo, setNumeroGrupo] = useState(null);
  const [error, setError] = useState(null);
  const [mensajeAlumno, setMensajeAlumno] = useState(null);

  const handleSearchSubmit = async (event) => {
    event.preventDefault();
    if (!searchValue.trim()) {
      setError("Por favor, ingrese un valor antes de buscar.");
      return;
    }

    setError(false);
    try {
      const searchParam = searchType === "matricula" ? "matricula" : "curp";
      const response = await axios.get(
        `${BASE_API}/api/alumno/?${searchParam}=${searchValue}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const alumno = response.data[0];
      setAlumnoData(alumno);
      setError(null);

      const calificacionesResponse = await axios.get(
        `${BASE_API}/api/calificacion_curso/?alumno=${alumno.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      setCalificacionesData(calificacionesResponse.data);
    } catch (error) {
      setError("No hay registro de este alumno");
      setAlumnoData(null);
      setCalificacionesData([]);
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    const obtenerYSetearNumeroGrupo = async () => {
      const numeroGrupoObtenido = await obtenerNumeroGrupo(
        alumnoData?.id,
        auth
      );
      setNumeroGrupo(numeroGrupoObtenido);
    };

    obtenerYSetearNumeroGrupo();
  }, [alumnoData, auth]);

  const obtenerNumeroGrupo = async (idAlumno, auth) => {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const grupos = response.data;
      const grupoConAlumno = grupos.find((grupo) =>
        grupo.alumnos.includes(idAlumno)
      );

      if (grupoConAlumno) {
        return grupoConAlumno.numero_grupo;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error al obtener el número de grupo:", error);
      return null;
    }
  };

  const obtnerAniosCicloEscolar = (fecha_Inicio, fecha_Fin) => {
    const fechaInicio = new Date(fecha_Inicio);
    const fechaFin = new Date(fecha_Fin);
    return `${fechaInicio.getFullYear()}-${fechaFin.getFullYear()}`;
  };

  const convertirNumeroARomano = (numero) => {
    const romanos = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII"];
    return romanos[numero - 1] || "";
  };

  const agruparCalificacionesPorSemestre = (calificaciones) => {
    const semestresOrdenados = [
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
    ];
    const calificacionesPorSemestre = {};
    calificaciones.forEach((calificacion) => {
      const semestre = calificacion.curso_data.materia_data.semestre;
      if (!calificacionesPorSemestre[semestre]) {
        calificacionesPorSemestre[semestre] = [];
      }
      calificacionesPorSemestre[semestre].push(calificacion);
    });

    for (const semestre in calificacionesPorSemestre) {
      calificacionesPorSemestre[semestre].sort((a, b) =>
        a.curso_data.materia_data.id > b.curso_data.materia_data.id ? 1 : -1
      );
    }
    const calificacionesOrdenadas = {};
    semestresOrdenados.forEach((semestre) => {
      if (calificacionesPorSemestre[semestre]) {
        calificacionesOrdenadas[semestre] = calificacionesPorSemestre[semestre];
      }
    });
    return calificacionesOrdenadas;
  };

  const calcularPromedioSemestre = (calificaciones) => {
    let suma = 0;
    let contador = 0;
    let fechaRegularizacion = null;

    for (const calificacion of calificaciones) {
      let notaFinal = calificacion.calificacion_final;
      let notaRegularizacion1 = calificacion.regularizacion_1;
      let notaRegularizacion2 = calificacion.regularizacion_2;

      if (notaFinal === null) {
        return {
          promedio: null,
          mensaje: "No han sido capturadas todas las calificaciones.",
        };
      }

      if (notaFinal <= 5) {
        if (notaRegularizacion1 !== null) {
          if (notaRegularizacion1 > 5) {
            notaFinal = notaRegularizacion1;
            fechaRegularizacion = calificacion.fecha_regularizacion_1;
          }
        }

        if (notaRegularizacion1 <= 5 && notaRegularizacion2 !== null) {
          if (notaRegularizacion2 > 5) {
            notaFinal = notaRegularizacion2;
            fechaRegularizacion = calificacion.fecha_regularizacion_2;
          }
        }
      }

      suma += parseFloat(notaFinal);
      contador++;
    }

    const promedio = (suma / contador).toFixed(3);
    return { promedio, fechaRegularizacion };
  };

  const calificacionesPorSemestre =
    agruparCalificacionesPorSemestre(calificacionesData);

  const promediosPorSemestre = Object.keys(calificacionesPorSemestre).reduce(
    (acc, semestre) => {
      const { promedio, fechaRegularizacion, mensaje } =
        calcularPromedioSemestre(calificacionesPorSemestre[semestre]);
      acc[semestre] = { promedio, fechaRegularizacion, mensaje };
      return acc;
    },
    {}
  );

  function formatearFecha(fecha) {
    const meses = [
      "ENE",
      "FEB",
      "MAR",
      "ABR",
      "MAY",
      "JUN",
      "JUL",
      "AGO",
      "SEP",
      "OCT",
      "NOV",
      "DIC",
    ];

    // Crear una nueva instancia de Date sin ajustar la zona horaria
    const fechaObj = new Date(`${fecha}T00:00:00`);
    const dia = fechaObj.getUTCDate().toString().padStart(2, "0");
    const mes = meses[fechaObj.getUTCMonth()];
    const año = fechaObj.getUTCFullYear().toString().slice(-2);

    return `${dia}-${mes}-${año}`;
  }

  // Cálculo del promedio general
  const calcularPromedioGeneral = (promedios) => {
    let sumaPromedios = 0;
    let contador = 0;

    for (const semestre in promedios) {
      if (promedios[semestre]?.promedio) {
        sumaPromedios += parseFloat(promedios[semestre].promedio);
        contador++;
      }
    }

    if (contador === 0) return "N/A";

    return (sumaPromedios / contador).toFixed(3);
  };

  const promedioGeneral = calcularPromedioGeneral(promediosPorSemestre);

  useEffect(() => {
    const generarMensajeAlumno = async (
      alumnoData,
      calificacionesPorSemestre
    ) => {
      const semestresRegistrados = Object.keys(
        calificacionesPorSemestre
      ).length;
      const semestreActual = alumnoData?.semestre;
      const estadoAlumno = alumnoData?.estado_alumno;

      if (semestreActual > semestresRegistrados) {
        if (estadoAlumno === "Activo") {
          const numeroGrupo = await obtenerNumeroGrupo(alumnoData?.id, auth);
          return `El alumno(a) está activo actualmente, debe registrar sus cursos y grupos correspondientes hasta ${convertirNumeroARomano(
            semestreActual
          )} semestre. Este semestre se encuentra registrado en el grupo ${numeroGrupo}`;
        } else if (estadoAlumno === "Baja temporal") {
          return `El alumno(a) se encuentra en estado de baja temporal actualmente, por lo que no tiene un grupo asignado ni cursos registrados`;
        } else {
          return `El alumno(a) está dado de baja permanente`;
        }
      }
      return null;
    };

    const obtenerMensajeAlumno = async () => {
      if (alumnoData && calificacionesPorSemestre) {
        const mensaje = await generarMensajeAlumno(
          alumnoData,
          calificacionesPorSemestre
        );
        setMensajeAlumno(mensaje);
      }
    };

    obtenerMensajeAlumno();
  }, [alumnoData, calificacionesPorSemestre, auth]);

  const verCurso = async (data) => {
    const params = new URLSearchParams();
    params.append("datosCurso", JSON.stringify(data));
    params.append("alumnoId", alumnoData.id);
    window.open(`/cursos/AlumnosCurso?${params.toString()}`, "_blank");
  };

  const generarKardex = async () => {
    try {
      const excelTemplateResponse = await axios.get(
        `${BASE_API}/api/kardex-template/`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const excelData = excelTemplateResponse.data;
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(excelData);
      const worksheet = workbook.getWorksheet("kardex");

      // Asignar datos encabezado
      worksheet.getCell("C10").value =
        alumnoData.apellido_paterno.toUpperCase();
      worksheet.getCell("K10").value =
        alumnoData.apellido_materno.toUpperCase();
      worksheet.getCell("O10").value = alumnoData.nombre.toUpperCase();
      const descripcionPlan =
        calificacionesData[0].curso_data.materia_data.plan_estudio_data
          .descripcion;
      const anioPlanRegistrado = descripcionPlan.split(" ").pop();
      worksheet.getCell("R8").value = anioPlanRegistrado;
      worksheet.getCell("C12").value = alumnoData.curp.toUpperCase();
      worksheet.getCell("M12").value = alumnoData.matricula || " ";

      // Definir las filas de inicio para cada bloque
      const bloquesFilasInicio = [18, 31, 45, 58, 73, 86, 99, 110];
      const periodoGrupoFilasInicio = [15, 28, 42, 55, 70, 83, 96, 107];

      // Recorrer los semestres y asignar los datos a las celdas correspondientes
      Object.keys(calificacionesPorSemestre).forEach((semestre, index) => {
        const calificaciones = calificacionesPorSemestre[semestre];
        const filaInicio = bloquesFilasInicio[index];
        const filaPeriodoGrupo = periodoGrupoFilasInicio[index];
        if (filaInicio) {
          calificaciones.forEach((calificacion, i) => {
            const fila = filaInicio + i;
            if (i < 9) {
              worksheet.getCell(`B${fila}`).value =
                calificacion.curso_data.materia_data.clave_materia || "";
              worksheet.getCell(`D${fila}`).value =
                calificacion.curso_data.materia_data.nombre_materia || "";
              worksheet.getCell(`L${fila}`).value =
                calificacion.calificacion_final || "";
              worksheet.getCell(`M${fila}`).value =
                calificacion.porcentaje_asistencia || "";
              worksheet.getCell(`N${fila}`).value =
                calificacion.fecha_regularizacion_1 !== null
                  ? formatearFecha(calificacion.fecha_regularizacion_1)
                  : "";
              worksheet.getCell(`O${fila}`).value =
                calificacion.regularizacion_1 !== null
                  ? parseInt(calificacion.regularizacion_1)
                  : "";
              worksheet.getCell(`P${fila}`).value =
                calificacion.fecha_regularizacion_2 !== null
                  ? formatearFecha(calificacion.fecha_regularizacion_2)
                  : "";
              worksheet.getCell(`Q${fila}`).value =
                calificacion.regularizacion_2 !== null
                  ? parseInt(calificacion.regularizacion_2)
                  : "";
            }
          });

          // Asignar el primer valor del periodo escolar y número de grupo
          const primerCalificacion = calificaciones[0];
          if (primerCalificacion) {
            worksheet.getCell(`H${filaPeriodoGrupo}`).value = primerCalificacion
              .curso_data.periodo_data.ciclo_escolar_data.fecha_inicio
              ? obtnerAniosCicloEscolar(
                  primerCalificacion.curso_data.periodo_data.ciclo_escolar_data
                    .fecha_inicio,
                  primerCalificacion.curso_data.periodo_data.ciclo_escolar_data
                    .fecha_fin
                )
              : "";
            worksheet.getCell(`L${filaPeriodoGrupo}`).value =
              primerCalificacion.curso_data.grupo_data.numero_grupo || "";
          }
        }
      });
      worksheet.getCell("Q118").value = promedioGeneral || " ";

      // Determinar el nombre del archivo
      const fileName = `kardex alumno ${
        alumnoData.matricula ? alumnoData.matricula : alumnoData.curp
      }.xlsx`;

      // Guardar el libro de Excel
      const excelBuffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([excelBuffer]), fileName);
    } catch (error) {
      console.error("Error al generar el archivo Excel:", error);
      toast.error("Error al generar el archivo Excel");
    }
  };

  return (
    <>
      <h1 className="tituloin">KARDEX</h1>

      <h3>Buscar alumno</h3>
      <Form className="form-inline" onSubmit={handleSearchSubmit}>
        <Form.Group inline>
          <Form.Field>
            <Radio
              label="Matrícula"
              name="searchType"
              value="matricula"
              checked={searchType === "matricula"}
              onChange={(e, { value }) => setSearchType(value)}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="CURP"
              name="searchType"
              value="curp"
              checked={searchType === "curp"}
              onChange={(e, { value }) => setSearchType(value)}
            />
          </Form.Field>
          <Form.Field>
            <input
              type="text"
              placeholder={
                searchType === "matricula"
                  ? "Ingrese la matrícula"
                  : "Ingrese el CURP"
              }
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Form.Field>
          <Button type="submit" className="botonEnviar">
            {!alumnoData ? "Buscar" : "Refrescar"}
          </Button>
        </Form.Group>
      </Form>

      {error && <Message negative>{error}</Message>}

      {alumnoData && (
        <div style={{ textAlign: "center" }}>
          <h2>Datos del Alumno</h2>
          {alumnoData.alumno_traslado && (
            <p
              style={{
                fontSize: "small",
                fontWeight: "bold",
                marginRight: "5px",
              }}
            >
              Traslado
            </p>
          )}
          <p>
            <strong>Nombre:</strong> {alumnoData.nombre}{" "}
            {alumnoData.apellido_paterno} {alumnoData.apellido_materno} |{" "}
            <strong>Matrícula:</strong> {alumnoData.matricula} |{" "}
            <strong>Semestre:</strong>{" "}
            {convertirNumeroARomano(alumnoData.semestre)} |{" "}
            <strong>CURP:</strong> {alumnoData.curp}|{" "}
          </p>
          <strong>Estado del alumno(a):</strong> {alumnoData.estado_alumno}
        </div>
      )}

      {calificacionesData?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "12px",
          }}
        >
          <Button
            icon="file excel"
            content="Descargar kardex"
            className="descarga"
            onClick={generarKardex}
          />
        </div>
      )}

      {alumnoData && alumnoData.estado_alumno && (
        <>
          {calificacionesData.length > 0 ? (
            <div style={{ textAlign: "center" }}>
              {Object.keys(calificacionesPorSemestre).map((semestre, index) => (
                <div key={semestre}>
                  <Table celled striped textAlign="center">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell colSpan={1}>
                          Semestre{" "}
                          {
                            calificacionesPorSemestre[semestre][0].curso_data
                              .materia_data.semestre
                          }
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={1}>
                          Periodo Escolar{" "}
                          {obtnerAniosCicloEscolar(
                            calificacionesPorSemestre[semestre][0].curso_data
                              .periodo_data.ciclo_escolar_data.fecha_inicio,
                            calificacionesPorSemestre[semestre][0].curso_data
                              .periodo_data.ciclo_escolar_data.fecha_fin
                          )}
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={7}>
                          Grupo{" "}
                          {
                            calificacionesPorSemestre[semestre][0].curso_data
                              .grupo_data.numero_grupo
                          }
                        </Table.HeaderCell>
                      </Table.Row>
                      <Table.Row>
                        <Table.HeaderCell>Clave</Table.HeaderCell>
                        <Table.HeaderCell>Curso</Table.HeaderCell>
                        <Table.HeaderCell>Calificación Final</Table.HeaderCell>
                        <Table.HeaderCell>% Asistencia</Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>
                          Calificación R1
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan={2}>
                          Calificación R2
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {Array.isArray(calificacionesPorSemestre[semestre]) &&
                      calificacionesPorSemestre[semestre].length > 0 ? (
                        calificacionesPorSemestre[semestre].map(
                          (calificacion, index) => {
                            const calFinal =
                              calificacion.calificacion_final !== null
                                ? parseFloat(calificacion.calificacion_final)
                                : "Pendiente";
                            return (
                              <Table.Row key={index}>
                                <Table.Cell>
                                  {
                                    calificacion.curso_data.materia_data
                                      .clave_materia
                                  }
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {
                                    calificacion.curso_data.materia_data
                                      .nombre_materia
                                  }
                                  <span
                                    className="eye-icon"
                                    title="Ir a curso"
                                    onClick={() => {
                                      verCurso(calificacion.curso_data);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i className="eye icon"></i>
                                  </span>
                                </Table.Cell>
                                <Table.Cell>{calFinal}</Table.Cell>
                                <Table.Cell>
                                  {calificacion.porcentaje_asistencia !== null
                                    ? calificacion.porcentaje_asistencia
                                    : "Pendiente"}
                                </Table.Cell>
                                <Table.Cell>
                                  {calificacion.regularizacion_1 || ""}
                                </Table.Cell>
                                <Table.Cell>
                                  {calificacion.fecha_regularizacion_1 || ""}
                                </Table.Cell>
                                <Table.Cell>
                                  {calificacion.regularizacion_2 || ""}
                                </Table.Cell>
                                <Table.Cell>
                                  {calificacion.fecha_regularizacion_2 || ""}
                                </Table.Cell>
                              </Table.Row>
                            );
                          }
                        )
                      ) : (
                        <Table.Row>
                          <Table.Cell colSpan="8">
                            {alumnoData?.estado_alumno === "Baja temporal"
                              ? "Está dado de baja temporalmente."
                              : alumnoData?.estado_alumno === "Baja definitiva"
                              ? "Está dado de baja definitivamente."
                              : alumnoData?.estado_alumno === "Activo"
                              ? `Es alumno activo pero este periodo no está añadido a ningún curso. Añádalo en los cursos correspondientes a su grupo: ${obtenerNumeroGrupo(
                                  alumnoData?.id
                                )} y periodo`
                              : "Estado de alumno desconocido."}
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                    <Table.Footer>
                      <Table.Row>
                        <Table.HeaderCell colSpan="8" textAlign="right">
                          Promedio:{" "}
                          {alumnoData?.estado_alumno !== "Activo" &&
                          promedioGeneral === "N/A"
                            ? `El alumno esta dado de ${alumnoData?.estado_alumno}`
                            : promediosPorSemestre[semestre]?.mensaje
                            ? promediosPorSemestre[semestre].mensaje
                            : promediosPorSemestre[semestre]?.promedio}
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Footer>
                  </Table>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>
              <Table celled striped textAlign="center">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan={1}>
                      Semestre{" "}
                      {alumnoData
                        ? convertirNumeroARomano(alumnoData.semestre)
                        : "I"}
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan={1}>
                      Periodo Escolar
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan={7}>Grupo</Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell>Clave</Table.HeaderCell>
                    <Table.HeaderCell>Curso</Table.HeaderCell>
                    <Table.HeaderCell>Calificación Final</Table.HeaderCell>
                    <Table.HeaderCell>% Asistencia</Table.HeaderCell>
                    <Table.HeaderCell colSpan={2}>
                      Calificación R1
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan={2}>
                      Calificación R2
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell colSpan="8">
                      {alumnoData?.estado_alumno === "Baja temporal"
                        ? "Está dado de baja temporalmente."
                        : alumnoData?.estado_alumno === "Baja definitiva"
                        ? "Está dado de baja definitivamente."
                        : alumnoData?.estado_alumno === "Activo" &&
                          numeroGrupo !== null &&
                          (alumnoData?.alumno_traslado
                            ? `Es alumno de traslado, por favor registre sus calificaciones correspondientes a sus semestres anteriores respetando sus períodos y grupos. Actualmente pertenece al grupo ${numeroGrupo}`
                            : `Es alumno activo pero este período no está añadido a ningún curso. Añádalo en los cursos correspondientes a su grupo: ${numeroGrupo} y anteriores.`)}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan="8" textAlign="right">
                      Promedio:{" No hay cursos registrados"}
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </div>
          )}
        </>
      )}

      {alumnoData && calificacionesData.length > 0 && mensajeAlumno && (
        <Message warning style={{ width: "98%", textAlign: "center" }}>
          <Message.Header>Atención</Message.Header>
          <p>{mensajeAlumno}</p>
        </Message>
      )}

      {alumnoData && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: "16px",
          }}
        >
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="2" textAlign="right">
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell textAlign="center">
                        Promedio General De Aprovechamiento
                      </Table.Cell>
                      <Table.Cell textAlign="center">
                        {promedioGeneral}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </div>
      )}

      {alumnoData?.fecha_baja_temporal_1 ||
      alumnoData?.fecha_baja_temporal_2 ||
      alumnoData?.fecha_baja_definitiva ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <strong>
            El alumno tiene los siguientes registros de fechas de Bajas
          </strong>
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "12px",
        }}
      >
        {alumnoData?.fecha_baja_temporal_1 && (
          <>
            <div>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="4" textAlign="center">
                    <Table>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell
                            textAlign="justify"
                            style={{ minWidth: "120px" }}
                          >
                            Baja temporal 1:
                          </Table.Cell>
                          <Table.Cell
                            style={{ minWidth: "90px" }}
                            textAlign="center"
                          >
                            {formatearFecha(alumnoData.fecha_baja_temporal_1)}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </div>
          </>
        )}
        {alumnoData?.fecha_baja_temporal_2 && (
          <>
            <div>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="4" textAlign="center">
                    <Table>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell
                            textAlign="justify"
                            style={{ minWidth: "120px" }}
                          >
                            Baja temporal 2:
                          </Table.Cell>
                          <Table.Cell
                            style={{ minWidth: "90px" }}
                            textAlign="center"
                          >
                            {formatearFecha(alumnoData.fecha_baja_temporal_2)}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </div>
          </>
        )}
        {alumnoData?.fecha_baja_definitiva && (
          <>
            <div>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="4" textAlign="center">
                    <Table>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell
                            textAlign="justify"
                            style={{ minWidth: "120px" }}
                          >
                            <p style={{ color: "red", fontWeight: "bold" }}>
                              Baja definitiva:
                            </p>
                          </Table.Cell>
                          <Table.Cell
                            style={{ minWidth: "90px" }}
                            textAlign="center"
                          >
                            {formatearFecha(alumnoData.fecha_baja_definitiva)}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </div>
          </>
        )}
        <ToastContainer />
      </div>
    </>
  );
}
export default KardexAlumnos;
